export default __webpack_public_path__ + "static/media/logoweb.d7151701.png";